module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUoAAADGAgMAAADJQiGBAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEXvM0D///8Ao+D8IOH+AAAAAWJLR0QB/wIt3gAAAAd0SU1FB+gGDwIlI6jwo0IAAABRSURBVHja7cwxDQAwCAAwJO7BH/dUzgIkJHtaAY0AAAAAAOCrXHecTqfT6XQ6nU6n0+l0Op1Op9M5OO+6cjqdTqfT6XQ6nU6n0+l0Op1OZ/98N5pN+HiWy0UAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjQtMDYtMTVUMDI6Mzc6MzQrMDA6MDBRvAN3AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDI0LTA2LTE1VDAyOjM3OjM0KzAwOjAwIOG7ywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/lsb.png
// module id = Zpew
// module chunks = 128